module.exports = __webpack_public_path__ + "img/left.e94bc5d0.png";